import cartData from '#shared/util/cartData.js';

import cButton from '#themes/default/default/components/button/button.js';
import cCross from '#themes/default/default/components/cross/cross.js';
import cOfferModal from '#themes/default/default/components/offerModal/offerModal.js';
import cPaymentFailedModal from '#themes/default/default/components/paymentFailedModal/paymentFailedModal.js';
import cPaymentIframeModal from '#themes/default/default/components/paymentIframeModal/paymentIframeModal.js';

import template from './modal.html' with { type: 'html' };

export default {
	...cartData,
	name: 'CModal',
	components: {
		cButton,
		cCross,
		cOfferModal,
		cPaymentFailedModal,
		cPaymentIframeModal
	},
	data() {
		return {
			ariaDescribedByEl: null,
			previouslyFocusedElement: null
		};
	},
	computed: {
		isCloseableModal() {
			return !['paymentIframe'].includes(this.modal);
		},
		unfocusableAreas() {
			const pageLayout = document.querySelector('.pageLayout');
			const footer = document.querySelector('.footer');
			return [pageLayout, footer];
		}
	},
	watch: {
		previouslyFocusedElement() {
			const button = this.$refs[`button_${this.modal}`];
			if (button) {
				button.focus();
			}
		}
	},
	mounted() {
		this.ariaDescribedByEl = document.getElementById(`${this.modal}_h2`) ? `${this.modal}_h2` : null;
		setTimeout(() => {
			this.previouslyFocusedElement = document.activeElement;
		}, 200);
		this.addFocusListener();
	},
	beforeDestroy() {
		this.removeFocusListener();
	},
	methods: {
		addFocusListener() {
			// Focus modal if you focus in to the array elements (layout or footer)
			this.unfocusableAreas.forEach((element) => element.addEventListener('focusin', this.focusModal));
		},
		removeFocusListener() {
			this.unfocusableAreas.forEach((element) => element.removeEventListener('focusin', this.focusModal));
		},
		focusModal() {
			this.$refs.modal.focus();
		},
		closeModal() {
			if (!this.isCloseableModal) {
				return;
			}
			this.$store.commit('SET_MODAL', '');
			if (this.order.isGuest && this.modal === 'paymentFailed') {
				this.loadFreshCart();
			} else if (this.previouslyFocusedElement) {
				this.previouslyFocusedElement.focus();
			}
		},
		async continueOrder() {
			// Run global (CGlobal component) checkout form handler
			await this.$root.$children.at(0).handleFormSubmit();
		},
		isStillModal(activeElement, modal) {
			const focusableElements = [...modal.querySelectorAll('a, input, button')];
			let isFocusable = false;
			focusableElements.forEach((focusableElement) => {
				if (focusableElement === activeElement) {
					isFocusable = true;
				}
			});
			return isFocusable;
		},
		trapFocus() {
			setTimeout(() => {
				if (!this.isStillModal(document.activeElement, this.$el)) {
					this.focusModal();
				}
			}, 0);
		},
		loadFreshCart() {
			this.$store.commit('SET_LOADER', true);
			location.href = this.retargetingUrl;
		}
	},
	template
};
